import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=6e907412&"
import script from "./LangSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LangSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VMenu,VToolbarTitle})
